module.exports = __webpack_public_path__ + "static/media/photo-tile-01_500.3841747a.jpg";